import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import {AlertController, Events, NavController, NavParams, ToastController} from 'ionic-angular';
import {UserData} from "../../providers/user-data";

import { PopoverController } from 'ionic-angular';
import { MessagingPopover } from './popover';
import {MessagingPage} from "../account/messaging/messaging";
import * as moment from "moment";

@Component({
    selector: 'page-contact',
    templateUrl: 'support.html',
    queries: {
        content: new ViewChild('content')
    }
})
export class SupportPage {

    submitted: boolean = false;
    supportMessage: string;
    supportMessagePrefix: false;
    threadKey: string;
    pageName: string;
    thread: any;
    messages: any;
    timer: any;
    content: any;
    userRef:any;
    sessionRef:any;

    @ViewChild('message') myInput ;

    constructor(
        public navCtrl: NavController,
        public alertCtrl: AlertController,
        public userData: UserData,
        public toastCtrl: ToastController,
        public params: NavParams,
        public popoverCtrl: PopoverController,
        public events: Events
    ) {
        moment.locale('fr');
        this.threadKey=params.get('thread');
        this.supportMessage=params.get('message');
        this.supportMessagePrefix = false;

        if(params.get('prefix'))
            this.supportMessagePrefix=params.get('prefix');

        if(!this.threadKey){
            this.threadKey = 'support';
            this.pageName = 'Support Novaterim'
        }
        else
        {
            this.pageName = 'Discussion'
        }

        this.messages = [];
    }
    scrollBottom()
    {
        if(this.content != null)
        this.content.scrollToBottom(300);
    }
    presentPopover(event: Event) {
        let popover = this.popoverCtrl.create(MessagingPopover);
        var that = this;
        popover.onDidDismiss(data => {
            if(data == 'messaging')
            {
                that.navCtrl.push(MessagingPage);
            }
            if(data == 'delete')
            {

            }
        });
        popover.present({ ev: event });
    }
    loadMessages()
    {
        this.thread = this.userData.get('messages/'+this.threadKey);

        if(this.thread.messages)
        {
            if(this.thread.name)
            {
                this.pageName = this.thread.name;
            }
            var messages = [];
            for(let i=0;i<Object.keys(this.thread.messages).length;i++)
            {
                let mkey = Object.keys(this.thread.messages)[i];
                messages.push(this.thread.messages[mkey]);
                this.userData.update('messages/'+this.threadKey,'read',true);
            }
            this.messages = messages.sort(function (a, b) {
                if (a.time < b.time) {
                    return -1;
                }
                else if (a.time > b.time) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        }

        var that = this;
        setTimeout(function(){
            that.scrollBottom();
        },300);

    }
    ngAfterViewInit() {



    }
    ionViewWillLeave() {
        //if(this.timer)clearInterval(this.timer);
        var that = this;

        this.userRef.unsubscribe();
        this.sessionRef.unsubscribe();
        //that.userData.load().unsubscribe();
    }
    ionViewWillEnter() {

        var that = this;
        that.sessionRef = that.userData.userSession().subscribe(session => {
            if(session!==null) {
                that.userRef = that.userData.load().subscribe(data => {
                    that.loadMessages();
                });
            }
        });

    }

    submit(form: NgForm) {
        this.submitted = true;

        if (form.valid) {
            if(this.supportMessagePrefix)
                this.supportMessage = this.supportMessagePrefix + '\n' + this.supportMessage;
            this.userData.localPush('messages/'+this.threadKey,'messages',{
                'from':this.userData.get('messaging_id'),
                'from_name':this.userData.get('messaging_id'),
                'time':Date.now(),
                'message':this.supportMessage,
                'read':false,
                'status':'pending'
            });

            this.supportMessage = '';
            this.submitted = false;
            if(this.threadKey =="support") {
                let toast = this.toastCtrl.create({
                    message: 'Votre message a été envoyé. Nos équipes vous répondrons le plus rapidement possible.',
                    duration: 3000
                });
                toast.present();
            }
            this.loadMessages();
            var that = this;
            setTimeout(function(){
                that.scrollBottom();
            },1000);

        }
    }

    // If the user enters text in the support question and then navigates
    // without submitting first, ask if they meant to leave the page
    ionViewCanLeave(): boolean | Promise<boolean> {
        // If the support message is empty we should just navigate
        if (!this.supportMessage || this.supportMessage.trim().length === 0) {
            return true;
        }

        return new Promise((resolve: any, reject: any) => {
            let alert = this.alertCtrl.create({
                title: 'Vous souhaitez quitter cette page ?',
                message: 'Votre message n\'a pas été envoyé.'
            });
            alert.addButton({ text: 'Continuer', handler: reject });
            alert.addButton({ text: 'Quitter la page', role: 'cancel', handler: resolve });

            alert.present();
        });
    }
    formatDate(date)
    {


        var format = moment(date,"DD/MM/YYYY HH:mm");
        var string =  format.fromNow();

        return string[0].toUpperCase() + string.substring(1);
    }
}



// WEBPACK FOOTER //
// ./src/pages/support/support.ts